import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, ref } from 'vue';
// Props für v-model definieren
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextInput',
    props: {
        modelValue: {
            type: String,
            required: true
        }
    },
    emits: ['update:modelValue'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        // emit für v-model definieren
        const emit = __emit;
        const input = ref(null);
        const model = ref(props.modelValue);
        // Synchronisierung des Modells mit dem v-model
        const updateModel = () => {
            emit('update:modelValue', model.value);
        };
        onMounted(() => {
            if (input.value?.hasAttribute('autofocus')) {
                input.value?.focus();
            }
        });
        __expose({ focus: () => input.value?.focus() });
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
                class: "rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                ref_key: "input",
                ref: input,
                onInput: updateModel
            }, null, 544)), [
                [_vModelText, model.value]
            ]);
        };
    }
});
